import { $appendTextToRoot } from '#pplx/frontend/composer-sdk/lexical/utils/editorTextOperations.js';
import { COMMAND_PRIORITY_HIGH, DROP_COMMAND } from 'lexical';
export function dropCommand(editor) {
    return editor.registerCommand(DROP_COMMAND, (event) => {
        const dataTransfer = event.dataTransfer;
        if (dataTransfer === null || dataTransfer.types.includes('Files')) {
            return false;
        }
        const text = dataTransfer.getData('text/plain');
        if (!text) {
            return false;
        }
        // Prevent default text insertion — Composer owns the controlled Lexical update.
        event.preventDefault();
        $appendTextToRoot(text);
        return true;
    }, COMMAND_PRIORITY_HIGH);
}
//# sourceMappingURL=dropCommand.js.map